/**
 * Discount display schedule reader.
 *
 * The schedule itself lives in `data/discounts.toml` and is injected into
 * `window.VANYX_CONFIG.discountSchedule` by base.html. This module only reads it
 * and decides whether the discount window is currently open.
 *
 * The shop shows the label-based discount (struck-through price + "-XX %" badge)
 * only while the window is open. Keep the TOML window aligned with the matching
 * Shopify *automatic* discount (Messerabatt) — Shopify applies the real discount
 * at checkout, so a mismatch would show a sale price the checkout does not honour.
 */

export function getSchedule() {
  const cfg = window.VANYX_CONFIG || {};
  return cfg.discountSchedule || { startsAt: "", endsAt: "" };
}

/**
 * @param {number} [now] epoch ms (defaults to Date.now()); injectable for tests
 * @returns {boolean} whether the discount display window is currently open
 */
export function isDiscountActive(now = Date.now()) {
  const { startsAt, endsAt } = getSchedule();

  const start = startsAt ? Date.parse(startsAt) : NaN;
  if (Number.isNaN(start) || now < start) {
    return false;
  }

  if (endsAt) {
    const end = Date.parse(endsAt);
    if (!Number.isNaN(end) && now >= end) {
      return false;
    }
  }

  return true;
}
